// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__JY7VB","message":"NotFound_message__-9hSt"};